export default __webpack_public_path__ + "static/飞书20210918-142430-91a287ecd0dccee4ab00c5a86deef1a7.png";